/**
 * Created by Jerker Nord on 2021-01-28.
 */
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {gsap} from "gsap";
import {BS2} from "../BS2";
import {SimpleSpinReelModel} from "../../core/reel/simplereel/SimpleSpinReelModel";
import {SimpleReelModelSymbolData} from "../../core/reel/simplereel/SimpleReelModel";
import {BS2Statics} from "../config/BS2Statics";
import {WildSymbol} from "../reels/WildSymbol";
import {SplitLine} from "../view/parts/SplitLine";
import {XSplitDirection} from "../server/BS2Data";
import {BetFeature} from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/bethandler/BetFeatureController";
import {BS2Sound} from "../config/sound/BS2Sound";

export class BS2IdleNormalPresentation implements FlowStatePresentation {
    constructor() {

    }

    public start(flowStateController: FlowStateController) {
        BS2.reelView.addTextToProgressionBar.emptyContainer();
        BS2.model.buyFeatureName=""; //198
        const activeBetFeature: BetFeature | undefined = BS2.apiPlugin.betFeatureController.getActiveBetFeature();
        if (activeBetFeature?.name === BS2Statics.BOOSTED_BET_2) {
            BS2.soundPlayer.fadeOutLoopMusic(BS2Sound.XBET2_LOOP);
            BS2.soundPlayer.fadeInLoopMusic(BS2Sound.SFS_INTRO_LOOP,1);
        }

        BS2.normalBet.makeBetDoneAndStartDoneFalse();
        BS2.model.hasWonFsClient = false;
        flowStateController.finish();
    }
}